let mod = null;

/**
 * @return {{hasFunction:Function(String),}|Object}
 * @constructor
 */
export default function RtModule(){
    mod = window['__rt_module'];
    if(!mod.hasFunction){
        mod.hasFunction = function(name){
            return mod.hasOwnProperty(name) && typeof mod[name] === 'function';
        }
    }
    if(!mod.get){
        mod.get = function(name){
            if(!mod.hasOwnProperty(name) || typeof mod[name] !== 'function'){
                Log.debug("Function not found:" + name);
                return null;
            }
            return mod[name];
        }
    }
    return mod;
}
